import { Icon } from './Icon';

type Step = { title: string; subtitle?: string };

type StepperProps = {
  steps: Step[];
  current: number; // 1-based
};

/**
 * Horizontal four-step stepper from the MAFA design system. Past steps
 * get a check mark; the current one gets the accent treatment; future
 * ones stay neutral. The connector bar between steps tints accordingly.
 */
export function Stepper({ steps, current }: StepperProps) {
  const active = steps[current - 1];
  return (
    <>
      {/* Mobile-only heading: on narrow screens the per-step labels are hidden
          (see global.css) and replaced by a single "Étape N / total — Titre"
          line so the stepper stays a compact row of numbered dots. */}
      {active && (
        <div className="stepper-mobile-head">
          Étape {current} / {steps.length} · {active.title}
        </div>
      )}
      <div className="stepper">
      {steps.map((s, i) => {
        const n = i + 1;
        const cls = n < current ? 'done' : n === current ? 'cur' : '';
        return (
          <div key={i} className="step-group" style={{ display: 'flex', alignItems: 'center', flex: '1 1 0', minWidth: 0 }}>
            <div className={`step ${cls}`}>
              <div className="num">{n < current ? <Icon name="check" /> : n}</div>
              <div className="stx">
                <div className="stt">{s.title}</div>
                {s.subtitle && <div className="sts">{s.subtitle}</div>}
              </div>
            </div>
            {i < steps.length - 1 && (
              <div
                className="step-connector"
                style={{
                  height: 2,
                  background: n < current ? 'var(--accent)' : 'var(--line)',
                  flex: '0 1 60px',
                  margin: '0 6px',
                  borderRadius: 2,
                }}
              />
            )}
          </div>
        );
      })}
      </div>
    </>
  );
}
